import { IDriverInitialState } from "../../../types/master/driverInterface";
import { DriverActionTypes, DriverActions } from "../../actionTypes/master/driverActionType";

const initialState: IDriverInitialState = {
  driverList: [],
  driverData: {
    id: 0,
    driver_name: "",
    driver_code: "",
    contact_number: "",
    alternate_contact_number: "",
    address: "",
    pincode: "",
    aadhaar_card_no: "",
    pan_card_no: "",
    father_name: "",
    mother_name: "",
    license_number: "",
    license_expiry_date: "",
    salary: 0,
    joining_date: "",
    leaving_date: "",
    photo_url: "",
    aadhaar_card_url: "",
    pan_card_url: "",
    bank_passbook_url: "",
    other_document_url: "",
    created_by: 0,
    createdAt: "",
    updatedAt: "",
    license_url: "",
    profile_status: "",
    type: ""
  },
  driverListPageCount: 0,
};

export default function driverReducer(state = initialState, action: DriverActionTypes): IDriverInitialState {
  switch (action.type) {
    
    case DriverActions.SET_DRIVER_LIST:
      return {
        ...state,
        driverList: action.payload,
      };

    case DriverActions.SET_DRIVER_LIST_PAGE_COUNT:
      return {
        ...state,
        driverListPageCount: action.payload,
      };

    case DriverActions.SET_DRIVER_DATA_BY_ID:
      return {
        ...state,
        driverData: action.payload,
      };

    default:
      return state;
  }
}
